import { AppState } from '../types'
import { RegionApiCodes } from '../../../types/types'

export const getRegionCode = (state: AppState): RegionApiCodes => {
  return state.region.apiCode || 'belgium-uat'
}
